import axiosClient from "../";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class sportsIframeService {
  static getLaunchIframe(params) {
    return axiosClient
      .get("/user/launchIframe", { params })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
